import jwtDecode from 'jwt-decode';
import constants from '../constants/constants';
import Logger from '../support/logger';

const { cookieDomain, setcookie } = window;
const log = new Logger();

export default {
  data: {
    v2: vm => ({
      forgotPassword() {
        vm.step = 'resetStart';
      },
      login() {
        return new Promise((resolve) => {
          log.debug({
            category: 'v2',
            message: 'login',
            data: {
              email: vm.loginData.username
            }
          });
          const data = {
            audience: constants.auth0.audience,
            client_id: constants.auth0.clientId,
            grant_type: constants.auth0.grantType,
            password: vm.loginData.password,
            popup: false,
            realm: constants.auth0.realm,
            scope: constants.auth0.scope,
            username: vm.loginData.username
          };

          try {
            vm.$http.post(constants.auth0.login, data)
              .then(({ body: { id_token: idToken, access_token: accessToken } }) => {
                resolve({ idToken, accessToken });
              }, ({ status, body }) => {
                log.warn({
                  category: 'v2',
                  message: `login.${status}`,
                  data: { body }
                });
                resolve(false);
              });
          } catch (error) {
            log.exception(error);
            resolve(false);
          }
        });
      },
      processResetPasswordResult(result) {
        if (!result) {
          vm.processing = false;
          return;
        }

        const email = vm.loginData.username;
        const payload = JSON.stringify({
          email
        });

        vm.$http.post(constants.v2.reset, payload)
          .then(() => {
            vm.step = 'submitted';
            vm.processing = false;
            vm.errorObj = false;
          }, ({ status, body }) => {
            log.warn({
              category: 'v2',
              message: `processResetPasswordResult.${status}`,
              data: { body }
            });
          })
          .catch((error) => {
            log.exception(error);
          });
      },
      recordActivity(response) {
        let tenantId = 'unknown';
        let token;

        try {
          token = jwtDecode(response.idToken);
          tenantId = token['https://api.material.com/tenant'];
        } catch (e) {
          log.exception(e);
          this.redirect(response);
          return;
        }

        const payload = {
          action: 'login',
          tenantId,
          value: vm.loginData.username
        };

        log.debug({
          category: 'v2',
          message: 'recordActivity',
          data: {
            payload
          }
        });

        vm.$http.post(constants.v2.activity, payload)
          .then(() => {
            this.redirect(response);
          }, ({ status, body }) => {
            log.warn({
              category: 'v2',
              message: `recordActivity.${status}`,
              data: { body }
            });
            this.redirect(response);
          })
          .catch((error) => {
            log.exception(error);
            this.redirect(response);
          });
      },
      redirect(response) {
        log.debug({
          category: 'v2',
          message: 'redirect',
          data: {
            accessToken: response.accessToken,
            idToken: response.idToken
          }
        });
        vm.processing = false;
        vm.submitBtnTxt = constants.redirectingText;

        if (response.idToken !== '') {
          setcookie('id_token', response.idToken, 1, cookieDomain, false);
        }

        if (response.accessToken !== '') {
          setcookie('access_token', response.accessToken, 1, cookieDomain, false);
        }

        window.location.href = constants.v2.admin;
      },
      resetPassword() {
        vm.processing = true;

        vm.$validator.validateAll()
          .then(this.processResetPasswordResult);
      }
    })
  }
};
